// extracted by mini-css-extract-plugin
export default {"con":"Payment_con__cYq-6"};